module.exports = __webpack_public_path__ + "static/img/banner-01.e76f147e.webp";